import { render, staticRenderFns } from "./CompetitorsKeywordsGrid.vue?vue&type=template&id=0cfa7d04&scoped=true&"
import script from "./CompetitorsKeywordsGrid.vue?vue&type=script&lang=js&"
export * from "./CompetitorsKeywordsGrid.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorsKeywordsGrid.vue?vue&type=style&index=0&id=0cfa7d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa7d04",
  null
  
)

/* custom blocks */
import block0 from "./CompetitorsKeywordsGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports